import MaterialFieldPreview from "@/components/Elements/FieldPreview/MaterialFieldPreview";
import { useGetObservationMaterialInfos } from "@/entities/observation";

export const TableCellMaterialInfo = ({ observation, field }) => {
  const { isLoading, ...info } = useGetObservationMaterialInfos(observation);

  return <MaterialFieldPreview value={info[field]} loading={isLoading} />;
};
